import axios from 'axios';
import { TemporaryProfile } from '../../types/temporary-profile.type';

// GET
// Returns temporary profiles for fishgroup.
// /ewosapi/v1/planandprognosis/temporaryprofiles/{fishGroupId}
export const getTemporaryPlanningProfiles = async (fishGroupId: string): Promise<TemporaryProfile[]> => {
  const res = await axios.get<TemporaryProfile[]>(`/ewosapi/v1/planandprognosis/temporaryprofiles/${fishGroupId}`);
  return res.data;
};
